import { Moon, Sun } from "lucide-react";
import useTheme from "@/lib/useTheme";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
      title={isDark ? "Mode clair" : "Mode sombre"}
      className={`relative inline-flex items-center justify-center w-9 h-9 text-[#4A5568] hover:text-[#C8A97E] transition-colors ${className}`}
    >
      <span className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${isDark ? "opacity-0 -rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"}`}>
        <Sun size={16} />
      </span>
      <span className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-50"}`}>
        <Moon size={16} />
      </span>
    </button>
  );
}
